import { initializeApp } from 'firebase/app'
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getMessaging, getToken as getFirebaseToken, onMessage, deleteToken } from 'firebase/messaging'
import { getFirestore } from "firebase/firestore"
import { getDatabase, ref, push, set, onDisconnect, onValue, update, serverTimestamp } from "firebase/database";


//https://blog.logrocket.com/push-notifications-with-react-and-firebase/

// Initialize the Firebase app in the service worker by passing the generated config
const hostname = window.location.hostname
let FIREBASE_CONFIG = null;
let VAPID_KEY = null;
if (hostname.includes("localhost") || hostname.includes("127.0.0.1") || hostname.includes("staging")) {
  FIREBASE_CONFIG = {
    apiKey: "AIzaSyDZriN_6mIoUWTbs_-OEttLt9R58qYNVE0",
    authDomain: "buggy-live-staging.firebaseapp.com",
    databaseURL: "https://buggy-live-staging.firebaseio.com",
    projectId: "buggy-live-staging",
    storageBucket: "buggy-live-staging.appspot.com",
    messagingSenderId: "641167209771",
    appId: "1:641167209771:web:983c97395e0ec2edf5016e",
    measurementId: "G-YZ7DWNSZWX"
  }
  VAPID_KEY = "BPkY6144XKqbu7zqAb-7a4usYyDE5Zlua9ykdANUC59LUl8qde1S1-2jnbUVyWRYeOdnvz0_7hXktelU_IdMBps"
} else {
  FIREBASE_CONFIG = {
    apiKey: "AIzaSyC3prAW9MjvzSTk4E87T_qd2U_-bCxoPcA",
    authDomain: "buggy-174216.firebaseapp.com",
    databaseURL: "https://buggy-174216-default-rtdb.firebaseio.com",
    projectId: "buggy-174216",
    storageBucket: "buggy-174216.appspot.com",
    messagingSenderId: "722998483799",
    appId: "1:722998483799:web:e060bbc2a4fccb0f51bc12"
  }
  VAPID_KEY = "BHV7RMqKyqNKml6rxiiH4sMP0Ens98sW__en0-UUWUTRxg7XGSg6tYIi-QeVRInV64pNAt3anDhgUFTmKeUFIHc"
}
// Initialize Firebase app
const firebaseApp = initializeApp(FIREBASE_CONFIG)
const auth = getAuth(firebaseApp);

// Initialize Firestore
const firestoreDb = getFirestore(firebaseApp, "bos-realtimedb")

// Check if Firebase messaging is supported
let messaging = null
if (typeof window !== 'undefined' && 'Notification' in window) {
  try {
    messaging = getMessaging(firebaseApp)
    
    try {
      await deleteToken(messaging);
    } catch (e) {
      console.warn("deleteToken error (ok to ignore):", e);
    }

  } catch (error) {
    console.error("Firebase messaging not supported or failed to initialize:", error)
  }
} else {
  console.log("Firebase messaging not supported on this browser.")
}

// Function to get the Firebase token
const getToken = (setTokenFound) => {
  if (messaging) {
    return getFirebaseToken(messaging, { vapidKey: VAPID_KEY })
      .then((currentToken) => {
        if (currentToken) {
          setTokenFound(currentToken)
        } else {
          console.log('No registration token available. Request permission to generate one.')
          setTokenFound(null)
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token.', err)
        setTokenFound(null)
      })
  } else {
    console.log("Messaging is not initialized.")
    setTokenFound(null)
  }
}

// Log in to Firebase with a custom JWT token
const loginToFirebaseWithToken = async (token) => {
  await signInWithCustomToken(auth, token);
}

// Function to listen for messages
const onMessageListener = (callback) =>
  new Promise((resolve) => {
    if (messaging) {
      onMessage(messaging, (payload) => {
        callback(payload)
        resolve(payload)
      })
    }
  })

const setupPresence = async (userId) => {
  try {
    if (!userId) return;
    const db = getDatabase(firebaseApp);
    const userStatusRef = ref(db, `/bosUserPresenceStatus/${userId}`);
    const connectionsRef = ref(db, `/bosUserPresenceStatus/${userId}/connections`);
    const thisConnRef = push(connectionsRef);

    await set(thisConnRef, true);
    onDisconnect(thisConnRef).remove();

    // Update last active periodically
    const touch = () => update(userStatusRef, { last_active: serverTimestamp() });
    touch();
    setInterval(touch, 60000);

    onValue(connectionsRef, async (snap) => {
      const online = !!snap.exists();
      await update(userStatusRef, {
        state: online ? "online" : "offline",
        last_active: serverTimestamp(),
        userGrapheneId: userId,
      });
    });
  } catch (error) {
    console.error("Error setting up presence:", error);
  }
}

export { messaging, getToken, onMessageListener, firestoreDb, setupPresence, loginToFirebaseWithToken }
